__webpack_require__.p = "/react-assignment/";